import light from './light'
import dark from './dark'
import icons from './icons.json'

export default { dark: { icons, ...dark }, light: { icons, ...light } }
